/**
 * api接口统一管理
 */
import { get,getByParams } from './http';
export default {
    get,getByParams
}
